import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";

const AdminLoginScreen = () => {
  return (
    <div>
      <AdminHeader />
      <AdminNavbar />
    </div>
  );
};

export default AdminLoginScreen;
